import { Link } from "react-router-dom";
import { Icon } from "components";
import { PROJECT, JOB, BILLABLE, RIGHT } from "icons";
import { ROUTE } from "@/lib/utils";

export const BillableBreadcrumbs = ({ billable }) => {
  if (!billable) return null;

  const project = billable?.job?.project;
  const job = billable?.job;

  return (
    <nav className="flex items-center text-sm">
      <Link
        to={ROUTE.PROJECT(project?.project_id)}
        className="flex items-center gap-2 px-2 py-1 rounded hover:bg-muted transition-colors"
      >
        <Icon icon={PROJECT} className="size-4 text-muted-foreground" />
        <span className="font-medium truncate max-w-[220px]">
          {project?.name}
        </span>
      </Link>
      <Icon icon={RIGHT} className="text-muted-foreground" />

      <Link
        to={ROUTE.JOB(job?.id)}
        className="flex items-center gap-2 px-2 py-1 rounded hover:bg-muted transition-colors"
      >
        <Icon icon={JOB} className="size-4 text-muted-foreground" />
        <span className="truncate max-w-[220px] font-medium">{job?.name}</span>
      </Link>
      <Icon icon={RIGHT} className="text-muted-foreground" />

      <div className="flex items-center gap-2 px-2 py-1">
        <Icon icon={BILLABLE} className="size-4 text-muted-foreground" />
        <span className="truncate max-w-[260px] font-medium">
          {billable?.name ?? "Billable"}
        </span>
      </div>
    </nav>
  );
};
